import styled, { keyframes } from "styled-components";
import { animationDuration, zIndex } from "../theme";
const left = 86;
const width = 256;

const showAnimation = () => keyframes`
  from {
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    left: ${left - width}px;
    opacity: 0;
  }
  to {
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1607843137254902);
    left: ${left}px;
    opacity: 1;
  }
`;

const hideAnimation = () => keyframes`
  from {
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1607843137254902);
    left: ${left}px;
    opacity: 1;
  }
  to {
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    left: ${left - width}px;
    opacity: 0;
  }
`;

export const StyledPanel = styled.div`
  animation-duration: ${animationDuration.slow}ms;
  animation-timing-function: cubic-bezier(0.12, 0.9, 0.3, 0.9);
  background: rgb(255 255 255 / 90%);
  border-right: 1px solid rgb(212 212 212);
  box-shadow: 0 4px 16px rgb(0 0 0 / 16%);
  backdrop-filter: blur(6px);
  box-sizing: border-box;
  inset: 0;
  left: ${left - width}px;
  opacity: 0;
  position: fixed;
  height: 100%;
  overflow-y: auto;
  width: ${width}px;
  z-index: ${zIndex.overContent};

  &.enter-active {
    animation-name: ${showAnimation};
  }

  &.enter-done {
    box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16.1%);
    left: ${left}px;
    opacity: 1;
  }

  &.exit-active {
    animation-name: ${hideAnimation};
  }
`;
